import { useState, useEffect } from 'react';

export default function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);

  const faqs = [
    {
      question: "Quels types de massages proposez-vous en Guadeloupe ?",
      answer: "Nous proposons une gamme complète de massages thérapeutiques : massage suédois, deep tissue, aux pierres chaudes, réflexologie plantaire, aromathérapie, et massages à domicile. Chaque technique est adaptée à vos besoins spécifiques de bien-être."
    },
    {
      question: "Combien coûte un massage de bien-être en Guadeloupe ?",
      answer: "Nos tarifs commencent à 65€ pour un massage découverte de 45 minutes. Un massage bien-être standard de 60 minutes coûte 80€. Les massages à domicile sont proposés à partir de 120€. Nous offrons également des forfaits avantageux."
    },
    {
      question: "Proposez-vous des massages à domicile en Guadeloupe ?",
      answer: "Oui, nous proposons tous nos services de massage à domicile dans la région de Pointe-à-Pitre et environs. Nous apportons tout le matériel nécessaire pour recréer l'ambiance spa chez vous. Le déplacement est inclus dans le tarif."
    },
    {
      question: "Comment réserver un massage thérapeutique ?",
      answer: "Vous pouvez réserver directement via notre assistant vocal en bas à droite de l'écran, par téléphone, ou en remplissant notre formulaire de contact. Nous confirmons votre rendez-vous dans les 2 heures et proposons des créneaux flexibles."
    },
    {
      question: "Vos thérapeutes sont-ils certifiés ?",
      answer: "Absolument ! Tous nos thérapeutes sont diplômés et certifiés en massothérapie. Ils ont plus de 10 ans d'expérience et se forment régulièrement aux nouvelles techniques de bien-être et de relaxation."
    },
    {
      question: "Quels sont les bienfaits des massages thérapeutiques ?",
      answer: "Nos massages offrent de nombreux bienfaits : réduction du stress, soulagement des tensions musculaires, amélioration de la circulation sanguine, meilleure qualité de sommeil, renforcement du système immunitaire, et bien-être mental général."
    },
    {
      question: "Utilisez-vous des produits naturels pour vos soins ?",
      answer: "Oui, nous privilégions les huiles essentielles et produits cosmétiques bio, notamment ceux produits localement en Guadeloupe. Nos huiles de massage sont 100% naturelles et adaptées au climat tropical."
    },
    {
      question: "Proposez-vous des forfaits pour couples ?",
      answer: "Nous proposons des forfaits couples très appréciés, que ce soit en centre ou à domicile. Ces séances permettent de partager un moment de détente privilégié avec ambiance romantique et champagne offert pour les forfaits à domicile."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  useEffect(() => {
    // Schema.org FAQPage pour le référencement
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Quels types de massages proposez-vous ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Nous proposons des massages relaxants, thérapeutiques, la réflexologie plantaire, l'aromathérapie et des soins holistiques personnalisés selon vos besoins."
          }
        },
        {
          "@type": "Question",
          "name": "Faut-il prendre rendez-vous à l'avance ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Oui, nous recommandons fortement de prendre rendez-vous à l'avance pour garantir votre créneau préféré. Vous pouvez réserver en ligne ou nous appeler directement."
          }
        },
        {
          "@type": "Question",
          "name": "Quels sont vos tarifs ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Nos tarifs varient selon le type de soin : massage relaxant 60€, massage thérapeutique 75€, réflexologie 55€. Des forfaits avantageux sont disponibles."
          }
        },
        {
          "@type": "Question",
          "name": "Où êtes-vous situés en Guadeloupe ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Notre centre de bien-être est situé à Pointe-à-Pitre, facilement accessible en transport en commun ou en voiture avec parking disponible."
          }
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Questions <strong>Fréquentes</strong> sur nos <strong>Massages</strong>
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Trouvez toutes les réponses sur nos services de <strong>bien-être</strong> 
            et <strong>massages thérapeutiques</strong> en <strong>Guadeloupe</strong>.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-teal-600 text-xl transition-transform`}></i>
                </div>
              </button>
              
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-gray-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-teal-50 rounded-xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Vous avez d'autres questions ?
            </h3>
            <p className="text-gray-600 mb-6">
              Notre équipe est là pour vous conseiller et vous aider à choisir 
              le massage qui vous convient le mieux.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-chat-voice-line mr-2"></i>
                Parler à un Conseiller
              </button>
              <button
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                Nous Contacter
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Schema.org FAQ Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
}
